import { Phone, MessageCircle } from "lucide-react";
import { toTelDigits } from "../lib/phone";

const TIERS = [
  {
    label: "Starter",
    range: "$1,200 – $2,500",
    period: "per week",
    desc: "First 60 days. Learning the territory, building your rhythm.",
  },
  {
    label: "Closer",
    range: "$2,500 – $5,000",
    period: "per week",
    desc: "Six months in. You know the pitch cold. The doors open faster.",
  },
  {
    label: "Top Performer",
    range: "$8,000+",
    period: "per week",
    desc: "Top 10% reps.",
  },
];

export const Earnings = ({ phone, whatsapp }) => {
  return (
    <section
      id="earnings"
      data-testid="earnings-section"
      className="relative py-24 md:py-32 bg-slate-900 text-white overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-10 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1772326281137-b617cbf77c5f?crop=entropy&cs=srgb&fm=jpg)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-blue-400 mb-4">
            Projected Earnings
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter font-bold text-white">
            Stop trading hours for pennies.
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-300 leading-relaxed">
            These are projections. These can be the weekly earning ranges for
            an active KnockWave rep. Your effort can write your check.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-slate-800 border border-slate-800">
          {TIERS.map((tier, idx) => (
            <div
              key={tier.label}
              data-testid={`earning-tier-${idx}`}
              className="bg-slate-900 p-8 md:p-10"
            >
              <p className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-400 mb-6">
                {tier.label}
              </p>
              <p className="font-heading text-4xl md:text-5xl font-bold tracking-tighter text-white">
                {tier.range}
              </p>
              <p className="mt-1 text-sm text-slate-400">{tier.period}</p>
              <p className="mt-6 text-base text-slate-300 leading-relaxed">
                {tier.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-5 justify-between border-t border-slate-800 pt-10">
          <div>
            <p className="font-heading text-2xl md:text-3xl font-semibold text-white tracking-tight">
              Ready to write your own number?
            </p>
            <p className="text-slate-400 mt-1">
              Talk to a Knockwave recruiter today. No commitment.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <a
              data-testid="earnings-call-cta"
              href={`tel:${toTelDigits(phone)}`}
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-100 text-slate-900 font-semibold px-6 py-3.5 rounded-md transition-all hover:-translate-y-0.5"
            >
              <Phone className="w-4 h-4" />
              Call {phone}
            </a>
            <a
              data-testid="earnings-whatsapp-cta"
              href={`https://wa.me/${toTelDigits(whatsapp)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE5A] text-white font-semibold px-6 py-3.5 rounded-md transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
